const id_rka_planning = {
    "": "perencanaan",
    add: "buat rencana",
    edit: "ubah rencana",
    detail: "detail rencana",

    label: {
        search: "No. Budgeting / Alias / Nama ",
        budgeting_number: "No. Budgeting",
        alias: "Alias",
        name: "Nama Rencana",
        price_ref: "Referensi Harga",
    },

    message: {
        reject_title: "Menolak Rencana",
        reject_text: "Apakah Anda yakin untuk menolak rencana ?",
    },

    error: {
        create: "Gagal membuat rencana",
        edit: "Gagal mengubah rencana",
        reject: "Gagal menolak rencana",
        approve: "Gagal menyetujui rencana",
    },

    success: {
        create: "Berhasil membuat rencana",
        edit: "Berhasil mengubah rencana",
        reject: "Berhasil menolak rencana",
        approve: "Berhasil menyetujui rencana",
    },
}

export default id_rka_planning;